// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../Config.bs.js";
import * as GAInit from "../library/ga/GAInit.bs.js";
import * as TdsFormWrapper from "../partner-web-apps/tds/components/TdsFormWrapper.bs.js";
import * as ErrorBoundaryHOC from "../library/error-boundary/ErrorBoundaryHOC.bs.js";
import * as SupportErrorView from "../partner-web-apps/support/components/SupportErrorView.bs.js";
import * as N_RnrLazyWrapperCmp from "../partner-web-apps/rnr-2w/view/components/N_RnrLazyWrapperCmp.bs.js";
import * as RnrDashboardWrapper from "../partner-web-apps/rnr/components/RnrDashboardWrapper.bs.js";
import * as N_RnrConfigLoaderCmp from "../partner-web-apps/rnr-2w/view/components/config-loader/N_RnrConfigLoaderCmp.bs.js";
import * as PartnerScoreDashboard from "../partner-web-apps/partner-score/view/components/common/PartnerScoreDashboard.bs.js";
import * as CircularLoader$Catalyst from "../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as TrackLiveTripWrapperCmp from "../partner-web-apps/track-live-trip/view/component/TrackLiveTripWrapperCmp.bs.js";
import * as IncentiveDashboardWrapper from "../partner-web-apps/incentive-dashboard/IncentiveDashboardWrapper.bs.js";
import * as InsuranceDashboardWrapper from "../partner-web-apps/insurance-dashboard/view/components/InsuranceDashboardWrapper.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var make = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, RnrDashboardWrapper.make);

var RnrDashboardProfiler = {
  tapToRetry: RnrDashboardWrapper.tapToRetry,
  RnrLoaderConfig: RnrDashboardWrapper.RnrLoaderConfig,
  RnrLoaderComponent: RnrDashboardWrapper.RnrLoaderComponent,
  $$default: RnrDashboardWrapper.$$default,
  make: make
};

var make$1 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, TdsFormWrapper.make);

var TdsFormProfiler = {
  TdsFormLoaderConfig: TdsFormWrapper.TdsFormLoaderConfig,
  TdsFormLoaderComponent: TdsFormWrapper.TdsFormLoaderComponent,
  $$default: TdsFormWrapper.$$default,
  make: make$1
};

var make$2 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, IncentiveDashboardWrapper.make);

var IncentiveDashboardProfiler = {
  make: make$2
};

var make$3 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, InsuranceDashboardWrapper.make);

var InsuranceDashboardProfiler = {
  make: make$3
};

var make$4 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, N_RnrLazyWrapperCmp.make);

var N_RnrDashboardProfiler = {
  RnrLazyWrapper: N_RnrLazyWrapperCmp.RnrLazyWrapper,
  Lazy: N_RnrLazyWrapperCmp.Lazy,
  make: make$4
};

var make$5 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, N_RnrConfigLoaderCmp.make);

var N_RnrConfigLoaderProfiler = {
  make: make$5
};

var make$6 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, TrackLiveTripWrapperCmp.make);

var TrackLiveTripProfiler = {
  reducer: TrackLiveTripWrapperCmp.reducer,
  $$default: TrackLiveTripWrapperCmp.$$default,
  make: make$6
};

var make$7 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, PartnerScoreDashboard.make);

var PartnerScoreDashboardProfiler = {
  make: make$7
};

var make$8 = Curry._1(Lib$PorterinFusionkitSentry.React.withProfiler, SupportErrorView.make);

var SupportErrorViewProfiler = {
  make: make$8
};

function getWebsiteComponentFromRoute(websiteRoute) {
  if (typeof websiteRoute === "number") {
    switch (websiteRoute) {
      case /* DefaultDashboard */0 :
          return React.createElement(ErrorBoundaryHOC.make, {
                      children: React.createElement("div", undefined, "Page Not Found")
                    });
      case /* CovidInstructions */1 :
          throw {
                RE_EXN_ID: "Match_failure",
                _1: [
                  "RouteComponentFactory.res",
                  47,
                  2
                ],
                Error: new Error()
              };
      case /* DefaultLoader */2 :
          return React.createElement(CircularLoader$Catalyst.make, {});
      
    }
  } else {
    switch (websiteRoute.TAG | 0) {
      case /* RnrDashboard */0 :
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* RnR */0), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make, {
                                uuid: websiteRoute._0,
                                authToken: websiteRoute._1,
                                language: websiteRoute._2,
                                version: websiteRoute._3,
                                version_code: websiteRoute._4
                              })
                        }));
      case /* N_RnrDashboard */1 :
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* RnR */0), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$4, {
                                uuid: websiteRoute._0,
                                auth_token: websiteRoute._1,
                                language: websiteRoute._2,
                                version: websiteRoute._3,
                                version_code: websiteRoute._4
                              })
                        }));
      case /* TdsForm */2 :
          return React.createElement(React.Suspense, {
                      children: React.createElement(ErrorBoundaryHOC.make, {
                            children: React.createElement(make$1, {
                                  uuid: websiteRoute._0
                                })
                          }),
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    });
      case /* IncentiveDashboard */3 :
          Curry._2(Lib$PorterinFusionkitSentry.React.setTag, "Pod", "IncentiveDashboard");
          Curry._2(Lib$PorterinFusionkitSentry.React.setTag, "country", Config.Env.infra_stack);
          return React.createElement(React.Suspense, {
                      children: React.createElement(ErrorBoundaryHOC.make, {
                            children: React.createElement(make$2, {
                                  msisdn: websiteRoute._0,
                                  auth_token: websiteRoute._1,
                                  language: websiteRoute._2
                                })
                          }),
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    });
      case /* TrackLiveTrip */4 :
          Curry._2(Lib$PorterinFusionkitSentry.React.setTag, "Pod", "TrackLiveTrip");
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* TrackLiveTrip */2), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$6, {
                                booking_id: websiteRoute._0,
                                customer_uuid: websiteRoute._1
                              })
                        }));
      case /* SupportView */5 :
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* PartnerApp */1), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$8, {
                                language: websiteRoute._0
                              })
                        }));
      case /* InsuranceDashboard */6 :
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* PartnerApp */1), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$3, {
                                uuid: websiteRoute._0,
                                auth_token: websiteRoute._1,
                                language: websiteRoute._2,
                                category: websiteRoute._3,
                                eligibility_status: websiteRoute._4,
                                geo_region: websiteRoute._5
                              })
                        }));
      case /* PartnerScoreDashboard */7 :
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* PartnerApp */1), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$7, {
                                msisdn: websiteRoute._0,
                                auth_token: websiteRoute._1,
                                language: websiteRoute._2,
                                vehicle_category: websiteRoute._3,
                                geo_region: websiteRoute._4
                              })
                        }));
      case /* DefaultErrorView */8 :
          return React.createElement(React.Suspense, {
                      children: React.createElement(ErrorBoundaryHOC.make, {
                            children: React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                  error: websiteRoute._0
                                })
                          }),
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    });
      case /* RnrConfigLoader */9 :
          Curry._2(Lib$PorterinFusionkitSentry.React.setTag, "Pod", "RnR");
          return React.createElement(React.Suspense, {
                      children: null,
                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                    }, GAInit.initGa4(/* RnR */0), React.createElement(ErrorBoundaryHOC.make, {
                          children: React.createElement(make$5, {
                                uuid: websiteRoute._0,
                                auth_token: websiteRoute._1,
                                language: websiteRoute._2,
                                version: websiteRoute._3,
                                version_code: websiteRoute._4
                              })
                        }));
      
    }
  }
}

export {
  RnrDashboardProfiler ,
  TdsFormProfiler ,
  IncentiveDashboardProfiler ,
  InsuranceDashboardProfiler ,
  N_RnrDashboardProfiler ,
  N_RnrConfigLoaderProfiler ,
  TrackLiveTripProfiler ,
  PartnerScoreDashboardProfiler ,
  SupportErrorViewProfiler ,
  getWebsiteComponentFromRoute ,
  
}
/* make Not a pure module */
